import 'css-chunksrc/feature/discount/DiscountPromoCodeInput.module.scss';export default {
  "textInput": "DiscountPromoCodeInput_textInput",
  "button": "DiscountPromoCodeInput_button"
};